import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconArrowBottomBold = ({ className }) => (
  <svg className={classNames('icon-arrow-bottom-bold', className)} width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.9" fillRule="evenodd" clipRule="evenodd" d="M14.3045 1.23141C12.9017 -0.387018 10.2222 -0.415924 8.7845 1.17896C5.9236 4.3526 1.68271 9.63755 0.112426 14.5909C-0.468613 16.4238 1.2855 18 3.46342 18H19.5115C21.7606 18 23.5273 16.3291 22.8556 14.4548C21.1212 9.61489 17.0495 4.39845 14.3045 1.23141Z" fill="#E1AA3B" />
  </svg>
);

IconArrowBottomBold.propTypes = {
  className: PropTypes.string,
};

IconArrowBottomBold.defaultProps = {
  className: '',
};

